/** @typedef {import('../../../types/index').VueAccessibleColorPicker.ColorHsl} ColorHsl */
/** @typedef {import('../../../types/index').VueAccessibleColorPicker.ColorRgb} ColorRgb */

/**
 * Converts an RGB color object to an HSL color object.
 *
 * Source: https://en.m.wikipedia.org/wiki/HSL_and_HSV#RGB_to_HSL_and_HSV
 *
 * @param {ColorRgb} rgb
 * @returns {ColorHsl}
 */
export function convertRgbToHsl(rgb) {
  const min = Math.min(rgb.r, rgb.g, rgb.b);
  const max = Math.max(rgb.r, rgb.g, rgb.b);

  let h;
  if (max === min) {
    h = 0;
  } else if (max === rgb.r) {
    h = (0 + (rgb.g - rgb.b) / (max - min)) / 6;
  } else if (max === rgb.g) {
    h = (2 + (rgb.b - rgb.r) / (max - min)) / 6;
  } else {
    h = (4 + (rgb.r - rgb.g) / (max - min)) / 6;
  }

  if (h < 0) {
    h += 1;
  }

  const l = (max + min) / 2;

  let s;
  if (max === 0 || min === 1) {
    s = 0;
  } else {
    s = (max - l) / Math.min(l, 1 - l);
  }

  return {
    h,
    s,
    l,
    // a: rgb.a,
  };
}
